(function ($) {
    'use strict';
    /**
     * переделывает список в select
     * */
    $.fn.makeCustomSelectFromList = function () {
        var $self = $(this);
        var $title = $self.find('.js-own-custom-select-title');
        var $button = $self.find('.js-own-custom-select-button');
        var $list = $self.find('.js-own-custom-select-list');
        var $subtitle = $self.find('.js-own-custom-select-subtitle');
        var $header = $self.find('.js-own-custom-select-header');
        var activeClass = 'active';

        /**
         * подставляет текст в select и в название статьи под select
         * */
        var initializationFirstParagraphs = function () {
            var element = $list.find('.js-tab-header').eq(0);
            insertsTextSubtitle(element);
            insertsTextHeader(element);
        };

        /**
         * удаляет активный класс с кнопки и с выпадающего списка
         * */

        var removeActiveClass = function () {
            $list.removeClass(activeClass);
            $button.removeClass(activeClass);
        };

        /**
         * подставляет текст в селект
         * */
        var insertsTextSubtitle = function (element) {
            var text = element.text();
            $subtitle.text(text);
        };

        /**
         * подставляет текст в заголовк под селектом
         * */
        var insertsTextHeader = function (element) {
            var subElement = element.find('.js-own-custom-text');
            var text;
            if (subElement.length > 0) {
                text = subElement.text();
                $header.text(text);
                return;
            };
            text = element.text();
            $header.text(text);
        };

        /**
         * инициализация плагина
         * */
        var init = function () {
            initializationFirstParagraphs();
            $title.on('click', function () {
                $list.toggleClass(activeClass);
                $button.toggleClass(activeClass);
            });

            $list.on('click', function (event) {
                removeActiveClass();
                var clickedElement = $(event.target).closest('.js-tab-header');
                if (clickedElement.length > 0) {
                    insertsTextSubtitle(clickedElement);
                    insertsTextHeader(clickedElement);
                }
            });
        };
        init();
        return this;
    };
    $('.js-own-custom-select').each(function () {
        $(this).data('makeCustomSelectFromList', $(this).makeCustomSelectFromList());
    });
})(jQuery);
